/**
 * Theme JS — ported from the original static prototype's main.js,
 * with cart/product/search/forms rewired to real Shopify endpoints.
 * Vanilla JS, no build step required.
 * =========================================================================
 */
(function () {
  "use strict";

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};

  /* =========================================================================
     TOAST UTILITY
     ========================================================================= */
  function showToast(message, isError) {
    var container = document.querySelector(".toast-container");
    if (!container) return;
    var toast = document.createElement("div");
    toast.className = "toast" + (isError ? " toast--error" : " toast--success");
    toast.setAttribute("role", "status");
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(function () {
      toast.classList.add("hiding");
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 3200);
  }

  /* =========================================================================
     1. STICKY HEADER SHADOW
     ========================================================================= */
  var siteHeader = document.querySelector(".site-header");
  if (siteHeader) {
    var onScroll = function () {
      siteHeader.classList.toggle("scrolled", window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* =========================================================================
     2. MOBILE NAV TOGGLE
     ========================================================================= */
  var hamburger = document.querySelector(".header-hamburger");
  var mobileNav = document.querySelector(".mobile-nav");
  if (hamburger && mobileNav) {
    hamburger.addEventListener("click", function () {
      var isOpen = hamburger.classList.toggle("open");
      mobileNav.classList.toggle("open", isOpen);
      document.body.style.overflow = isOpen ? "hidden" : "";
      hamburger.setAttribute("aria-expanded", String(isOpen));
    });
    document.addEventListener("click", function (e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        hamburger.classList.remove("open");
        mobileNav.classList.remove("open");
        document.body.style.overflow = "";
        hamburger.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* =========================================================================
     2b. HEADER DROPDOWN (e.g. "Catalog") — click-toggle + outside-click close
     Hover is handled purely by CSS; this adds click/keyboard support too,
     which matters for touch devices and accessibility.
     ========================================================================= */
  document
    .querySelectorAll(".header-nav__dropdown-trigger")
    .forEach(function (trigger) {
      var wrap = trigger.closest(".header-nav__dropdown-wrap");
      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = wrap.classList.toggle("open");
        trigger.setAttribute("aria-expanded", String(isOpen));
        document
          .querySelectorAll(".header-nav__dropdown-wrap.open")
          .forEach(function (other) {
            if (other !== wrap) {
              other.classList.remove("open");
              other
                .querySelector(".header-nav__dropdown-trigger")
                .setAttribute("aria-expanded", "false");
            }
          });
      });
    });
  document.addEventListener("click", function () {
    document
      .querySelectorAll(".header-nav__dropdown-wrap.open")
      .forEach(function (wrap) {
        wrap.classList.remove("open");
        wrap
          .querySelector(".header-nav__dropdown-trigger")
          .setAttribute("aria-expanded", "false");
      });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document
        .querySelectorAll(".header-nav__dropdown-wrap.open")
        .forEach(function (wrap) {
          wrap.classList.remove("open");
          wrap
            .querySelector(".header-nav__dropdown-trigger")
            .setAttribute("aria-expanded", "false");
        });
    }
  });

  // Mobile nav nested groups (accordion-style)
  document
    .querySelectorAll(".mobile-nav__group-trigger")
    .forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var group = trigger.closest(".mobile-nav__group");
        var isOpen = group.classList.toggle("open");
        trigger.setAttribute("aria-expanded", String(isOpen));
      });
    });

  /* =========================================================================
     3. SEARCH BAR TOGGLE
     ========================================================================= */
  document
    .querySelectorAll('[data-action="toggle-search"]')
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        var bar = document.getElementById("site-search");
        if (!bar) return;
        var isHidden = bar.hasAttribute("hidden");
        if (isHidden) {
          bar.removeAttribute("hidden");
          btn.setAttribute("aria-expanded", "true");
          var input = bar.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          bar.setAttribute("hidden", "");
          btn.setAttribute("aria-expanded", "false");
        }
      });
    });

  /* =========================================================================
     4. ACCORDION
     ========================================================================= */
  document.querySelectorAll(".accordion-trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".accordion-item");
      var panel = item.querySelector(".accordion-panel");
      var isOpen = item.classList.contains("open");
      item.classList.toggle("open", !isOpen);
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + "px";
      trigger.setAttribute("aria-expanded", String(!isOpen));
    });
  });

  /* =========================================================================
     5. PRODUCT CAROUSEL
     ========================================================================= */
  document.querySelectorAll(".carousel-wrap").forEach(function (wrap) {
    var carousel = wrap.querySelector(".carousel");
    var btnPrev = wrap.querySelector(".carousel-btn--prev");
    var btnNext = wrap.querySelector(".carousel-btn--next");
    if (!carousel) return;

    var scrollAmount = function () {
      var card = carousel.querySelector(".product-card");
      return card ? card.offsetWidth + 24 : 280;
    };
    var updateBtns = function () {
      if (!btnPrev || !btnNext) return;
      btnPrev.disabled = carousel.scrollLeft <= 0;
      btnNext.disabled =
        carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;
    };
    if (btnPrev)
      btnPrev.addEventListener("click", function () {
        carousel.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
      });
    if (btnNext)
      btnNext.addEventListener("click", function () {
        carousel.scrollBy({ left: scrollAmount(), behavior: "smooth" });
      });
    carousel.addEventListener("scroll", updateBtns, { passive: true });
    updateBtns();
  });

  /* =========================================================================
     6. PDP — GALLERY THUMBNAILS
     ========================================================================= */
  document.querySelectorAll(".pdp-gallery").forEach(function (gallery) {
    var mainImg = gallery.querySelector(".pdp-gallery__main img");
    var thumbs = gallery.querySelectorAll(".pdp-thumb");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.dataset.src;
        if (src) mainImg.src = src;
        thumbs.forEach(function (t) {
          t.classList.remove("active");
        });
        thumb.classList.add("active");
      });
    });
  });

  /* =========================================================================
     7. PDP — VARIANT PICKER
     Reads the product's variants JSON and resolves the matching variant
     as option buttons are clicked, then updates price / image / stock /
     the hidden "id" input used by the add-to-cart form.
     ========================================================================= */
  document.querySelectorAll("product-page").forEach(function (root) {
    var variantsScript = root.querySelector("[data-product-variants]");
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var form = root.querySelector(".product-form");
    var idInput = form ? form.querySelector("[data-variant-id-input]") : null;
    var priceEl = root.querySelector("[data-product-price]");
    var comparePriceEl = root.querySelector("[data-product-compare-price]");
    var stockEl = root.querySelector("[data-stock-indicator]");
    var addBtn = root.querySelector("[data-add-to-cart-btn]");
    var mainImg = root.querySelector(".pdp-gallery__main img");

    // Track current selection per option position, seeded from whichever
    // buttons are already marked .active by Liquid on page load.
    var selected = {};
    root.querySelectorAll(".variant-group").forEach(function (group) {
      var pos = group.dataset.optionPosition;
      var activeBtn = group.querySelector(".swatch.active, .size-btn.active");
      if (activeBtn) selected[pos] = activeBtn.dataset.optionValue;
    });

    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    function findMatchingVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selected).every(function (pos) {
          var idx = parseInt(pos, 10) - 1;
          return opts[idx] === selected[pos];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = "";
        } else {
          comparePriceEl.style.display = "none";
        }
      }
      if (variant.featured_image && variant.featured_image.src && mainImg) {
        mainImg.src = variant.featured_image.src.replace(
          /(\.[a-zA-Z]{3,4})(\?|$)/,
          "_800x$1$2",
        );
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? "Add to Cart" : "Sold Out";
      }
      if (stockEl) {
        if (!variant.available) {
          stockEl.innerHTML =
            '<span class="stock-dot stock-dot--out" aria-hidden="true"></span><span>Out of stock</span>';
        } else if (
          variant.inventory_management &&
          variant.inventory_quantity <= 5 &&
          variant.inventory_quantity > 0
        ) {
          stockEl.innerHTML =
            '<span class="stock-dot stock-dot--low" aria-hidden="true"></span><span>Only <strong>' +
            variant.inventory_quantity +
            "</strong> left in stock</span>";
        } else {
          stockEl.innerHTML =
            '<span class="stock-dot" aria-hidden="true"></span><span>In stock</span>';
        }
      }
    }

    root.querySelectorAll(".swatch, .size-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest(".variant-group");
        var pos = group.dataset.optionPosition;
        selected[pos] = btn.dataset.optionValue;

        group.querySelectorAll(".swatch, .size-btn").forEach(function (b) {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");

        var labelEl = group.querySelector("[data-selected-option-value]");
        if (labelEl) labelEl.textContent = btn.dataset.optionValue;

        applyVariant(findMatchingVariant());
      });
    });
  });

  /* =========================================================================
     8. QUANTITY CONTROLS (generic — PDP form + cart line items)
     ========================================================================= */
  function wireQtyControl(control, onChange) {
    var input = control.querySelector('input[type="number"]');
    var dec = control.querySelector('[data-action="decrease"]');
    var inc = control.querySelector('[data-action="increase"]');
    if (!input) return;

    var update = function (val, fire) {
      var min = parseInt(input.min, 10) || 0;
      var max = parseInt(input.max, 10) || 999;
      var next = Math.min(Math.max(val, min), max);
      var changed = String(next) !== input.value;
      input.value = next;
      if (dec) dec.disabled = next <= min;
      if (inc) inc.disabled = next >= max;
      if (fire && changed && onChange) onChange(next);
    };

    if (dec)
      dec.addEventListener("click", function () {
        update(parseInt(input.value, 10) - 1, true);
      });
    if (inc)
      inc.addEventListener("click", function () {
        update(parseInt(input.value, 10) + 1, true);
      });
    input.addEventListener("change", function () {
      update(parseInt(input.value, 10) || 1, true);
    });
    update(parseInt(input.value, 10) || 1, false);
  }

  document.querySelectorAll(".pdp-atc-row .qty-control").forEach(function (c) {
    wireQtyControl(c);
  });

  /* =========================================================================
     9. CART — AJAX API HELPERS
     ========================================================================= */
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function refreshCartCount() {
    fetch((routes.cartUrl || "/cart") + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch(routes.cartAddUrl || "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1 }],
      }),
    }).then(function (r) {
      if (!r.ok)
        return r.json().then(function (err) {
          throw err;
        });
      return r.json();
    });
  }

  function changeCartLine(line, quantity) {
    return fetch(routes.cartChangeUrl || "/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  // Quick-add buttons on product cards (collection grid, carousels, etc.)
  document.body.addEventListener("click", function (e) {
    var btn = e.target.closest('[data-action="add-to-cart"]');
    if (!btn || !btn.dataset.variantId) return;
    e.preventDefault();
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding...";
    addToCart(btn.dataset.variantId, 1)
      .then(function () {
        btn.textContent = "Added!";
        showToast(strings.addedToCart || "Item added to your cart");
        refreshCartCount();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function (err) {
        var message =
          (err && err.description) ||
          strings.cartError ||
          "Something went wrong.";
        showToast(message, true);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  // PDP add-to-cart form (full page form submit, intercepted for AJAX)
  document.querySelectorAll(".product-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var idInput = form.querySelector("[data-variant-id-input]");
      var qtyInput = form.querySelector('input[name="quantity"]');
      var submitBtn = form.querySelector("[data-add-to-cart-btn]");
      if (!idInput || !idInput.value) return;

      var originalText = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Adding...";
      }

      addToCart(idInput.value, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
        .then(function () {
          showToast(strings.addedToCart || "Item added to your cart");
          refreshCartCount();
          if (submitBtn) {
            submitBtn.textContent = "Added to Cart";
          }
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }
          }, 1600);
        })
        .catch(function (err) {
          var message =
            (err && err.description) ||
            strings.cartError ||
            "Something went wrong.";
          showToast(message, true);
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        });
    });
  });

  // Cart page — quantity change / remove (reloads to keep totals accurate)
  document.querySelectorAll(".cart-item").forEach(function (item) {
    var line = parseInt(item.dataset.line, 10);
    var control = item.querySelector(".qty-control");
    if (control) {
      wireQtyControl(control, function (newVal) {
        changeCartLine(line, newVal).then(function () {
          window.location.reload();
        });
      });
    }
    var removeBtn = item.querySelector('[data-action="remove-item"]');
    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        changeCartLine(line, 0).then(function () {
          window.location.reload();
        });
      });
    }
  });

  // Promo code — Shopify applies discount codes via a dedicated redirect URL
  document
    .querySelectorAll('[data-action="apply-discount"]')
    .forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="discount"]');
        var code = input && input.value.trim();
        if (!code) return;
        window.location.href =
          "/discount/" +
          encodeURIComponent(code) +
          "?redirect=" +
          encodeURIComponent(routes.cartPageUrl || "/cart");
      });
    });

  // Contact form — combine first/last name into the hidden contact[name]
  // field Shopify uses for the notification email, right before submit.
  var contactForm = document.getElementById("contact-form");
  if (contactForm) {
    contactForm.addEventListener("submit", function () {
      var first = contactForm.querySelector("#contact-first-name");
      var last = contactForm.querySelector("#contact-last-name");
      var nameField = contactForm.querySelector("[data-contact-name-combined]");
      if (nameField) {
        nameField.value = [first ? first.value : "", last ? last.value : ""]
          .join(" ")
          .trim();
      }
    });
  }

  /* =========================================================================
     10. PRODUCT RECOMMENDATIONS — LAZY LOAD VIA SECTION RENDERING API
     ========================================================================= */
  document
    .querySelectorAll("[data-product-recommendations]")
    .forEach(function (section) {
      var url = section.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var temp = document.createElement("div");
          temp.innerHTML = html;
          var grid = temp.querySelector(".product-recommendations__grid");
          if (grid && grid.children.length > 0) {
            section.querySelector(".product-recommendations__grid").innerHTML =
              grid.innerHTML;
          } else {
            section.style.display = "none";
          }
        })
        .catch(function () {
          section.style.display = "none";
        });
    });

  /* =========================================================================
     11. COLLECTION FILTER SIDEBAR (mobile open/close)
     ========================================================================= */
  var filterSidebar = document.getElementById("filter-sidebar");
  var filterOverlay = document.querySelector(".filter-sidebar-overlay");
  document
    .querySelectorAll('[data-action="toggle-filters"]')
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!filterSidebar) return;
        filterSidebar.classList.add("open");
        if (filterOverlay) filterOverlay.classList.add("show");
        btn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
      });
    });
  function closeFilters() {
    if (!filterSidebar) return;
    filterSidebar.classList.remove("open");
    if (filterOverlay) filterOverlay.classList.remove("show");
    document.body.style.overflow = "";
  }
  document
    .querySelectorAll('[data-action="close-filters"]')
    .forEach(function (btn) {
      btn.addEventListener("click", closeFilters);
    });
  if (filterOverlay) filterOverlay.addEventListener("click", closeFilters);

  // Collapsible filter groups
  document.querySelectorAll(".filter-group__title").forEach(function (title) {
    title.addEventListener("click", function () {
      var group = title.closest(".filter-group");
      group.classList.toggle("collapsed");
      var expanded = !group.classList.contains("collapsed");
      title.setAttribute("aria-expanded", String(expanded));
    });
  });

  /* =========================================================================
     12. PLP VIEW TOGGLE (grid column count — cosmetic only)
     ========================================================================= */
  document.querySelectorAll(".view-toggle").forEach(function (toggle) {
    var grid = document.querySelector(".product-grid");
    toggle.querySelectorAll(".view-toggle-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        toggle.querySelectorAll(".view-toggle-btn").forEach(function (b) {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");
        if (grid) {
          grid.classList.remove("product-grid--4col", "product-grid--2col");
          if (btn.dataset.cols === "4")
            grid.classList.add("product-grid--4col");
          if (btn.dataset.cols === "2")
            grid.classList.add("product-grid--2col");
        }
      });
    });
  });

  /* =========================================================================
     13. SCROLL-REVEAL ANIMATIONS (fade-up)
     ========================================================================= */
  var fadeEls = document.querySelectorAll('[data-animate="fade-up"]');
  if (fadeEls.length) {
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("animated");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 },
      );
      fadeEls.forEach(function (el) {
        el.style.opacity = "0";
        el.style.transform = "translateY(20px)";
        el.style.transition = "opacity 0.55s ease, transform 0.55s ease";
        el.style.transitionDelay = el.dataset.delay || "0s";
        observer.observe(el);
      });
      var style = document.createElement("style");
      style.textContent =
        '[data-animate="fade-up"].animated { opacity: 1 !important; transform: translateY(0) !important; }';
      document.head.appendChild(style);
    } else {
      fadeEls.forEach(function (el) {
        el.classList.add("animated");
      });
    }
  }
})();
